module.exports = __webpack_public_path__ + "static/minter-dd4459bfa8d57c0b9c3694376f9e2cde.png";